import { Theme, css } from '@emotion/react';

export const paymentMethodWrapper = (theme: Theme) => css`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacing(2)}px ${theme.spacing(2)}px;

  svg {
    width: ${theme.typography.pxToRem(70)};
    height: ${theme.typography.pxToRem(50)};
    justify-self: flex-end;
  }
`;

export const paymentStack = (theme: Theme) => css`
  margin-top: ${theme.spacing(1.5)}px;
`;
